export function checkValidImgFormat(url: string) {
    if (!url) {
        return '';
    }
    const validUrls = ['.png', '.tiff', '.jpeg', '.gif', '.pbm', '.bmp', '.tga', '.webp'];
    return validUrls.some((s) => url.endsWith(s)) ? 'webp' : '';
}
